import { UserRound, UsersRound } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

import { Page } from "@/components/page";
import { type PageTab, PageTabs } from "@/components/page-tabs";
import { PEOPLE_PATH, TEAMS_PATH } from "@/lib/navigation";

export { UsersPage } from "./users";

/**
 * Mensen en teams (admins), a layout route under `/people`: its title and a
 * row of tabs for its two parts, then the part that is open. Mensen
 * (`/people`) lists who can sign in to the dashboard, with their roles;
 * Teams (`/people/teams`) gives who may use which tools and apps through the
 * connector. Each part opens with its own controls, Teams with the rules
 * behind them.
 */
export function PeopleLayout() {
  const { t } = useTranslation();
  const tabs: PageTab[] = [
    { to: PEOPLE_PATH, label: t("people.tabs.users"), icon: UserRound, end: true },
    { to: TEAMS_PATH, label: t("people.tabs.teams"), icon: UsersRound },
  ];

  return (
    <Page title={t("nav.people")}>
      <PageTabs label={t("nav.people")} tabs={tabs} className="-mt-2 mb-6" />
      <Outlet />
    </Page>
  );
}
